
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/privacy",
      function () {
        return require("private-next-pages/policies/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/privacy"])
      });
    }
  